<template>
  <div id="knowledge">
    <!--     <div class="parent">
      <div class="card" v-for="(item, index) in directory">
        <div class="title">{{ item.name }}</div>
      </div>
    </div> -->
    <a-spin size="large" :spinning="spinning">
      <div class="books">
        <div class="book" v-for="(item, index) in directory" @click="folder(item.id)">
          <div>
            <span style="z-index: 100">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";

let router = useRouter();

import PageFooter from "@/components/PageFooter.vue";

const directory = ref([]);
const spinning = ref(false);

localStorage.setItem("router", "knowledge");

function folder(id) {
  router.push({
    name: "folder",
    params: {
      id: id,
    },
  });
}

spinning.value = true;
axios
  .post("api/KnowledgeClassify/GetJstreeDataAllowAnonymous")
  .then((response) => {
    if (response.data.code != 200) {
      message.error(response.data.info);
    } else {
      if (response.data.ReturnData[0].name == "根目录") {
        directory.value = response.data.ReturnData[0].children;
      }
    }
  })
  .catch((error) => {
    console.error(error);
  })
  .finally(() => {
    spinning.value = false;
  });
onMounted(() => {});
</script>

<style scoped>
.books {
  /*   display: flex;
  width: calc(12rem * 3 + 3rem * 2);
  justify-content: space-between;
  margin-top: 6rem; */
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-items: center;
  align-items: center;
  gap: 0px; /* 根据需要调整间隔 */
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  width: 1000px;
  font-size: 12px;
}

.book {
  width: 12rem;
  height: 18rem;
  background: linear-gradient(navy, deeppink, tomato);
  transform: skewY(-10deg);
  box-shadow: -10px 5px 30px rgba(0, 0, 0, 0.5);
  position: relative;
  transition: 0.3s;
  margin-bottom: 100px;
  cursor: pointer;
}

.book:hover {
  margin-top: -1.5rem;
}

.book::before,
.book > div::before {
  content: "";
  position: absolute;
  width: 1.5rem;
  height: 100%;
  background: linear-gradient(navy, deeppink, tomato);
  /*   background: linear-gradient(#9f025e, deeppink, #f9c929); */
  top: 0;
  left: -1.5rem;
  transform-origin: right;
  transform: skewY(45deg);
  filter: brightness(0.6);
  z-index: 1;
}

.book::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1.5rem;
  background: white;
  top: -1.5rem;
  left: 0;
  transform-origin: bottom;
  transform: skewX(45deg);
  filter: brightness(0.9);
}

.book > div {
  color: whitesmoke;
  font-size: 2.2rem;
  font-family: sans-serif;
  display: block;
  text-align: center;
  height: 8rem;
  margin-top: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  text-shadow: -2px 2px 10px rgba(0, 0, 0, 0.3);
  position: absolute;
  width: 100%;
  z-index: 100;
}

/* .book:nth-child(2n) {
  top: -3rem;
}

.book:nth-child(3n) {
  top: -6rem;
}

.book:nth-child(4n) {
  top: -9rem;
} */

/* .book:nth-child(2n) span,
.book:nth-child(2n) span::before {
  background: orange;
}

.book:nth-child(3n) span,
.book:nth-child(3n) span::before {
  background: royalblue;
} */

.book > div,
.book > div::before {
  z-index: 1;
  background: orange;
}

.book > div::after {
  z-index: 1;
  display: block;
  font-size: 1rem;
}

.book > span {
  z-index: 100;
}

#knowledge {
  padding: 150px 0px 50px 0px;
  background: linear-gradient(to bottom left, white, dimgray);
  min-width: 1200px;
  min-height: 100vh;
}
.parent {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-items: center;
  align-items: center;
  gap: 0px; /* 根据需要调整间隔 */
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  width: 1170px;
}
.card {
  width: 180px;
  height: 180px;
  background-color: #fff;
  border: 1px solid #d4d6db;
  box-sizing: border-box;
  box-shadow: none;
  transition: all 0.3s;
  margin-bottom: 30px;
  position: relative;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}
.card:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
.title {
  text-align: left;
  font-size: 16px;
  color: #1a1a1a;
  width: 100%;
  height: 22px;
  line-height: 22px;
  font-weight: 700;
  transition: all 0.3s;
}
.title:hover {
  color: #ff6a00;
}
</style>
